module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/345.0f25a279.png";